import './bootstrap.js';
import './assets/website/scripts/script.js'

import { createApp } from "vue";
import App from "./App.vue"

import router from "./route/frontend.js";

import { createPinia } from 'pinia';
import piniaPersist from 'pinia-plugin-persistedstate';

import loadWebsiteGlobalComponents from './plugin/websiteGlobalComponent.js';
import loadThirdParty from './plugin/thirdParty.js';
import { mountComponents  } from './mixins/frontendComponent.js';
import globalCrud from './mixins/crud.js';
const app = createApp(App);

// Pinia
const pinia = createPinia();
pinia.use(piniaPersist);
app.use(pinia);

// Load global components for SPA
app.use(loadWebsiteGlobalComponents);
app.use(loadThirdParty);
app.use(globalCrud);

// Global properties for SPA
app.config.globalProperties.baseUrl = window.baseUrl;
app.config.globalProperties.$toast = window.$toast;
app.config.globalProperties.$swal = window.Swal;

const main = document.getElementById('app');

// Mount main SP
if (main) {
    // Route setup
    app.use(router);
    app.mount(main);
}

// Mount backend blade components
mountComponents({
    pinia,
    router ,
    loadWebsiteGlobalComponents,
    loadThirdParty,
    globalCrud
});
